import { BASE_ALOFT_URL } from 'constants/envVars';
import axios from 'axios';
import { addAlert } from 'actions/alerts';
import { createErrorAlert } from 'utils/generalUtils';
import { handleSubmitNotifyEvent } from 'actions/firebase';
import { notifyCreateSuccessAlert } from 'constants/notifyAndFlyConstants';

export const submitNotify = body => async (dispatch, getState) => {
	try {
		const url = `${BASE_ALOFT_URL}/v1/flight-notifications`;
		const socketId = getState().app.pusherSocketId;
		const config = {
			headers: { 'X-Push-Socket-ID': socketId } //Stop Pusher from sending this client its own update
		};
		const response = await axios.post(url, body, config);
		if (response.data.data) {
			handleSubmitNotifyEvent(body.type);
			dispatch(addAlert(notifyCreateSuccessAlert));
		}
		return response.data.data;
	} catch (error) {
		const { errors } = error.response.data;
		for (const error in errors) {
			const alert = createErrorAlert({ error: errors[error][0], message: errors[error][0] });
			dispatch(addAlert(alert));
			console.error(errors[error][0]);
		}
		return errors;
	}
};
